import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_USER_REFERRALS } from "../../../api/queryKeys";
import { QueryUserReferralsResponse } from "../../../types";

export const getReferralData = () =>
  api
    .get<QueryUserReferralsResponse>(QUERY_USER_REFERRALS)
    .then((res) => res.data);

export default function useGetReferrals() {
  return useQuery([QUERY_USER_REFERRALS], getReferralData);
}
